import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { RolesTypes } from '../actions/actions.types'

type RolesState = ApplicationState['roles']

function rolesReducer(state: RolesState = new ImmutableMap(), action: IAction): RolesState {
	switch (action.type) {
		case RolesTypes.GetAllRoles.SUCCESS:
			return state.set('roles', action.payload)
	}
	return state
}

export default rolesReducer
